module.exports = __webpack_public_path__ + "static/template_options_year_months_as_columns-a9ef8460d254a5cef3fe3bb0e53d98f8.png";